import PriceHandler from './price-handlers/quantity-price-handler';
import { RADIO_SELECTOR } from '../../classnames/design-system';
import { QUANTITY_INPUT_NAME } from '../../classnames/above-the-fold';

export default class QuantityHandler {
  priceHandler = new PriceHandler();

  constructor(containers) {
    this.containers = containers;
  }

  handleClick = ({ target }, container) => {
    const quantity = parseFloat(target.getAttribute('value'));

    this.priceHandler.handle(quantity, container);
  };

  initializeEventListeners = () => {
    this.containers.forEach((container) => {
      const quantitySelectors = container.querySelectorAll(`${RADIO_SELECTOR}[name="${QUANTITY_INPUT_NAME}"]`);

      [...quantitySelectors].forEach((element) => element.addEventListener('click', (event) => {
        this.handleClick(event, container);
      }));
    });
  };
}
